"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
exports.GetRagIcon = function (ragIcon) {
    switch (ragIcon) {
        case "fa-check-circle":
            return free_solid_svg_icons_1.faCheckCircle;
        case "fa-question":
            return free_solid_svg_icons_1.faQuestion;
        default:
            return free_solid_svg_icons_1.faTimesCircle;
    }
};
exports.GetRagClass = function (ragClass) {
    switch (ragClass) {
        case "Green":
            return "success";
        case "Amber":
            return "warning";
        case "Red":
            return "danger";
        default:
            return "secondary";
    }
};
//# sourceMappingURL=RagIcon.js.map